import { useState, useEffect } from 'react';
import { StatusE } from '../../../models/enums';
import { ProjectT } from "../../../models/models";
import { useAppSelector } from "../../../store/hooks";

const useShownDeliveryStatusNameFromRTKQuery = (): StatusE => {
    const currentProject = useAppSelector(state => state.jumboMediaAPI.queries);
    const [resStatus, setResStatus] = useState<StatusE>();
    const pathParts = window.location.pathname.split('/');
    const deliveryNumber = +(pathParts[pathParts.length - 1]);

    useEffect(() => {
        if (deliveryNumber) {
            const delivery = (currentProject?.[`getProjectById({"id":"${deliveryNumber}"})`]?.data as ProjectT);

            if (delivery) {
                setResStatus(delivery?.StatusName as StatusE);
            }
        }
    }, [deliveryNumber]);

    return resStatus;
};

export default useShownDeliveryStatusNameFromRTKQuery;